import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import Select from "react-select";
import Cookies from "js-cookie";
import "../../styles/common/popup.scss";

const CreatePagePopupNew = ({
  open,
  handleClose,
  onSave,
  courseKey,
  subjectKey,
  topicKey,
  subTopicKey,
  editData,
  isSubPage = false,
  parentId = null,
  parentPageType = null,
}) => {
  const [name, setName] = useState("");
  const [pageType, setPageType] = useState(
    editData?.page_type === "material_item"
      ? editData?.material_type
      : editData?.page_type
  );
  const [duration, setDuration] = useState("");
  const [passPercentage, setPassPercentage] = useState("");
  const [isContentQuizEnabled, setIsContentQuizEnabled] = useState(true);

  const isSaveDisabled =
    !name.trim() ||
    (pageType === "test" &&
      (!String(duration).trim() ||
        !String(passPercentage).trim() ||
        Number(duration) <= 0 ||
        Number(passPercentage) < 0 ||
        Number(passPercentage) > 100));

  const getPageTypeOptions = () => {
    if (isSubPage) {
      if (parentPageType === "quiz") {
        return [
          { value: "mcq", label: "MCQ" },
          { value: "match", label: "Match" },
          { value: "fillups", label: "Fill Ups" },
          { value: "trueorfalse", label: "True or False" },
          // { value: "analysis", label: "Analysis" },
          // { value: "active_recall_content", label: "Active Recall Content" },
          // { value: "active_recall_test", label: "Active Recall Test" },
        ];
      } else if (parentPageType === "materials") {
        return [
          { value: "pdf", label: "PDF" },
          { value: "ppt", label: "PPT" },
          { value: "video", label: "Video" },
          { value: "audio", label: "Audio" },
          { value: "image", label: "Image" },
          { value: "doc", label: "Document" },
          { value: "mindmap", label: "Mindmap" },
        ];
      }
    } else {
      const role = Cookies.get("role");
      if (role === "institution" || role === "teacher") {
        return [{ value: "materials", label: "Materials" }];
      }
      return [
        { value: "content", label: "Content" },
        { value: "quiz", label: "Quiz" },
        { value: "test", label: "Test" },
        { value: "materials", label: "Materials" },
      ];
    }
  };

  const pageTypeOptions = getPageTypeOptions();

  const isEditMode = !!editData;

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "var(--color-bg)",
      borderColor: "var(--border-color)",
      color: "var(--color-text-dark)",
      minHeight: "40px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "var(--color-primary)",
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "var(--color-bg)",
      zIndex: 10001,
      position: "absolute",
      width: "100%",
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 10001,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "var(--color-primary)"
        : state.isFocused
          ? "var(--color-hover)"
          : "var(--color-bg)",
      color: state.isSelected ? "white" : "var(--color-text-dark)",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "var(--color-primary)"
          : "var(--color-hover)",
        color: state.isSelected ? "white" : "var(--color-text-dark)",
      },
      fontSize: "var(--fs-md)",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "var(--color-text-dark)",
      fontSize: "var(--fs-md)",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "var(--fs-md)",
    }),
  };

  const handleSave = () => {
    let actualPageType = pageType;
    let materialType = null;

    if (
      (isSubPage && parentPageType === "materials") ||
      editData?.page_type === "material_item"
    ) {
      materialType = pageType;
      actualPageType = "material_item";
    }

    const payload = {
      page_type: actualPageType,
      name: name,
      hierarcy_level: isSubPage ? 1 : 0,
    };

    if (actualPageType === "content") {
      payload.is_content_quiz_enabled = isContentQuizEnabled;
    }

    if (actualPageType === "material_item" && materialType) {
      payload.material_type = materialType;
    }

    if (actualPageType === "test") {
      const parsedDuration = Number(duration);
      const parsedPass = Number(passPercentage);
      if (!Number.isFinite(parsedDuration) || parsedDuration <= 0) {
        return;
      }
      if (!Number.isFinite(parsedPass) || parsedPass < 0 || parsedPass > 100) {
        return;
      }
      payload.duration = parsedDuration;
      payload.pass_percentage = parsedPass;
    }

    if (isSubPage && parentId) {
      payload.parent = parentId;
    }

    if (subTopicKey) {
      payload.subtopic_key = subTopicKey;
    } else if (topicKey) {
      payload.topic_key = topicKey;
    } else if (subjectKey) {
      payload.subject_key = subjectKey;
    } else if (courseKey) {
      payload.course_key = courseKey;
    }

    if (onSave) {
      onSave(payload);
    }
    handleClose();
  };

  useEffect(() => {
    if (open) {
      if (editData) {
        setName(editData.name || "");
        setPageType(
          editData.page_type === "material_item"
            ? editData.material_type
            : editData.page_type || "content"
        );
        setDuration(
          typeof editData.duration === "number" ||
            typeof editData.duration === "string"
            ? String(editData.duration)
            : "",
        );
        setPassPercentage(
          typeof editData.pass_percentage === "number" ||
            typeof editData.pass_percentage === "string"
            ? String(editData.pass_percentage)
            : "",
        );
        setIsContentQuizEnabled(
          editData.is_content_quiz_enabled !== undefined
            ? editData.is_content_quiz_enabled
            : true
        );
      } else {
        setName("");
        setPageType(pageTypeOptions.length > 0 ? pageTypeOptions[0].value : undefined);
        setDuration("");
        setPassPercentage("");
        setIsContentQuizEnabled(true);
      }
    }
  }, [open, editData]);

  return createPortal(
    <div
      className={`common-popup-overlay ${open ? "" : "hidden"} high-z-index`}
      onClick={handleClose}
    >
      <div
        className="common-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header">
          <h2>{isEditMode ? "Edit Page" : "Add Page"}</h2>
          <button className="popup-close-button" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="popup-content">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSave();
            }}
          >
            <div className="popup-form-group">
              <label htmlFor="page-name">Name of the page</label>
              <input
                id="page-name"
                type="text"
                className="popup-input"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="popup-form-group">
              <label htmlFor="page-type">Page Type</label>
              <Select
                id="page-type"
                className="popup-select-react"
                classNamePrefix="popup-select"
                value={pageTypeOptions.find(
                  (option) => option.value === pageType,
                )}
                onChange={(selectedOption) => setPageType(selectedOption.value)}
                options={pageTypeOptions}
                styles={selectStyles}
                isSearchable={false}
                isDisabled={isEditMode}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                fontSize="var(--fs-md)"
              />
            </div>

            {pageType === "content" && (
              <div className="popup-form-group">
                <label
                  htmlFor="content-quiz-enabled"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    cursor: "pointer",
                    fontWeight: 500,
                  }}
                >
                  <input
                    id="content-quiz-enabled"
                    type="checkbox"
                    checked={isContentQuizEnabled}
                    onChange={(e) => setIsContentQuizEnabled(e.target.checked)}
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <span>Enable Content Quiz</span>
                </label>
              </div>
            )}

            {pageType === "test" && (
              <>
                <div className="popup-form-group">
                  <label htmlFor="test-duration">Duration</label>
                  <input
                    id="test-duration"
                    type="number"
                    className="popup-input"
                    placeholder="Duration in minutes"
                    min={1}
                    step={1}
                    value={duration}
                    onChange={(e) =>
                      setDuration(e.target.value.replace(/[^0-9]/g, ""))
                    }
                  />
                </div>
                <div className="popup-form-group">
                  <label htmlFor="test-pass-percentage">
                    Pass Percentage (%)
                  </label>
                  <input
                    id="test-pass-percentage"
                    type="number"
                    className="popup-input"
                    placeholder="Pass percentage (0 - 100)"
                    min={0}
                    max={100}
                    step={1}
                    value={passPercentage}
                    onChange={(e) => {
                      const v = e.target.value.replace(/[^0-9]/g, "");
                      setPassPercentage(v);
                    }}
                  />
                </div>
              </>
            )}

            <div className="popup-actions">
              <button
                type="submit"
                className="popup-submit-button"
                disabled={isSaveDisabled}
              >
                {isEditMode ? "Save Changes" : "Add Page"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default CreatePagePopupNew;
